/*
 * @Descripttion:
 * @version: v1
 * @Author: liukx
 * @Date: 2022-05-05 20:23:32
 * @LastEditors: ???
 * @LastEditTime: 2022-05-07 23:15:39
 */
const getters = {
  sidebar: (state) => state.app.sidebar,
  language: (state) => state.app.language,
  size: (state) => state.app.size,
  device: (state) => state.app.device,
  avatar: (state) => state.user.avatar,
  name: (state) => state.user.name,
  introduction: (state) => state.user.introduction,
  roles: (state) => state.user.roles,
  addRouters: (state) => state.permission.addRouters,
  permission_routers: (state) => state.permission.routers,
  visitedViews: (state) => state.tagsView.visitedViews,
  cachedViews: (state) => state.tagsView.cachedViews,
  errorLogs: (state) => state.errorLog.logs,
  user_routes: (state) => state.user.user_routes,
};
export default getters;
